<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ADMIN_MICOAPP_API, apiErrorText, settingPayload } from "@/config/social-api";

/**
 * Starter page component
 */
export default {
    page() {
        return {
            title: this.title,
            meta: [{ name: "description" }],
        };
    },
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Starter page",
            items: [
                {
                    text: "Utility",
                    href: "/",
                },
                {
                    text: "Starter page",
                    active: true,
                },
            ],
            loading: false,
            appid: "",
            userinfo: [],
            points: {},
        };
    },
    mounted() {
        this.userinfo = JSON.parse(localStorage.getItem("user"));
        this.appid = this.$route.params.appid;
        this.title = "积分设置";
        this.items = [
            {
                text: this.$t("menuitems.micoapp.text"),
                href: "/",
            },
            {
                text: this.$t("menuitems.icp.micoapp.list"),
                href: "/micoapp",
            },
            {
                text: this.$t("menuitems.icp.micoapp.info"),
                href: `/micoapp/${this.appid}`,
            },
            {
                text: "积分设置",
                active: true,
            },
        ];
        this.getmicoappmenu();
    },
    methods: {
        getmicoappmenu() {
            var that = this;
            that.loading = true;
            that.$axios
                .post(
                    ADMIN_MICOAPP_API,
                    {
                        action: "getmicoappsetting",
                        appid: that.$route.params.appid,
                    },
                    {
                        headers: { Openid: that.userinfo.openid },
                    }
                )
                .then(function (response) {
                    that.loading = false;
                    that.points = JSON.parse(settingPayload(response.data).points);
                    that.points.points_switch = parseInt(that.points.points_switch);
                })
                .catch(function (error) {
                    that.loading = false;
                    that.$notify.error({
                        title: '请求错误',
                        message: error
                    });
                });
        },
        save_micoappsetting(type) {
            var that = this;
            let postdata = that[type];
            that.loading = true;
            if (postdata) {
                that.$axios
                    .post(
                        ADMIN_MICOAPP_API,
                        {
                            action: "save_micoappsetting",
                            appid: that.$route.params.appid,
                            type: type,
                            datas: postdata
                        },
                        {
                            headers: { Openid: that.userinfo.openid },
                        }
                    )
                    .then(function (response) {
                        that.loading = false;
                        if (response.data.status == 200) {
                            that.$message.success({
                                message: "保存成功"
                            });
                            that.getmicoappmenu();
                        } else {
                            that.$message.error({
                                message: apiErrorText(response.data, "保存失败")
                            });
                        }
                    })
                    .catch(function (error) {
                        that.loading = false;
                        that.$notify.error({
                            title: '请求错误',
                            message: error
                        });
                    });

            } else {
                that.$message.error({
                    message: "提交数据不存在"
                });
            }
        }
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="micoapp-page micoapp-point-page">
            <div class="row" v-loading="loading">
                <div class="col-12">
                    <div class="card micoapp-point-card">
                        <div class="card-body">
                            <div class="micoapp-toolbar">
                                <div class="micoapp-toolbar-title">
                                    <h5>积分设置</h5>
                                    <p>设置积分名称、比例与有效期</p>
                                </div>
                                <el-button type="primary" size="small" @click="save_micoappsetting('points')">
                                    保存
                                </el-button>
                            </div>
                            <el-form ref="form" :model="points" label-width="100px" class="micoapp-form micoapp-point-form">
                                <el-form-item label="积分名称">
                                    <el-input v-model="points.points_name" placeholder="如：积分、金币" maxlength="20" show-word-limit />
                                </el-form-item>
                                <el-form-item label="积分开关">
                                    <el-switch
                                        v-model="points.points_switch"
                                        :active-value="1"
                                        :inactive-value="0"
                                        active-text="开启"
                                        inactive-text="关闭"
                                    />
                                </el-form-item>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="获得比例">
                                            <el-input v-model="points.points_ratio" type="number" placeholder="请输入" />
                                            <div class="micoapp-form-hint">1元消费可获得多少积分</div>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="抵扣比例">
                                            <el-input v-model="points.points_cash" type="number" placeholder="请输入" />
                                            <div class="micoapp-form-hint">多少积分可抵扣1元现金</div>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-form-item label="积分有效期">
                                    <el-input v-model="points.points_validity" type="number" placeholder="0表示永久" />
                                    <div class="micoapp-form-hint">单位：天</div>
                                </el-form-item>
                                <el-form-item label="积分说明">
                                    <el-input
                                        v-model="points.describe"
                                        type="textarea"
                                        :rows="5"
                                        placeholder="向用户展示的积分规则说明"
                                    />
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
.micoapp-point-page .micoapp-point-card {
    margin-bottom: 1.5rem;
}

.micoapp-point-page .micoapp-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1.25rem;
}
.micoapp-point-page .micoapp-toolbar-title h5 {
    margin: 0 0 0.25rem 0;
    font-weight: 700;
}
.micoapp-point-page .micoapp-toolbar-title p {
    margin: 0;
    color: #6b7280;
    font-size: 0.9rem;
}

.micoapp-point-form {
    max-width: 560px;
}

.micoapp-form-hint {
    margin-top: 6px;
    font-size: 12px;
    color: #94a3b8;
    line-height: 1.4;
}
</style>
